import palette from '../palette';

const MuiTab = {
  styleOverrides: {
    root: {
      '& .MuiTabs-indicator': {
        backgroundColor: palette.primary.dark,
      },
      '&.Mui-selected': {
        color: palette.primary.dark,
      },
      color: palette.text.link,
    },
  },
};

export default MuiTab;
